import { injectContentsquareScript } from '@contentsquare/tag-sdk'

import store from '@/store'

const HOTJAR_ENABLED = import.meta.env.PROD && import.meta.env.VITE_HOTJAR_ID

export const initHotJar = () => {
    if (HOTJAR_ENABLED) {
        injectContentsquareScript({ siteId: import.meta.env.VITE_HOTJAR_ID })
        setHotJarUserProperties()
    }
}

export const setHotJarUserProperties = () => {
    if (HOTJAR_ENABLED && window.hj) {
        const { user } = store.getState().auth
        window.hj('identify', user?.id, {
            name: user?.name || null,
            email: user?.email || null,
            role: user?.role.key || null,
            company_name: user?.company?.name || null,
            company_unique_id: user?.company?.unique_id || null
        })
    }
}

export const hotJarEvent = (event: string) => {
    if (HOTJAR_ENABLED && window.hj) {
        window.hj('event', event)
    }
}

initHotJar()
